import Skeleton from "@Components/Skeleton";
import styles from "../../BlogPost.module.scss";
import wrapperHOC from "@Utils/wrapperHOC";
import { memo } from "react";

const BlogSkeleton = ({ isDesktop }: { isDesktop: boolean }) => (
  <div className={styles.blogContainer}>
    <div className={styles.breadcrumbsContainer}>
      <Skeleton width="300px" height="20px" mb="20px" />
    </div>
    <div className={styles.contentWrapper}>
      {/* Main Content Column Skeleton */}
      <div className={styles.mainColumn}>
        {/* Hero Image Skeleton */}
        <Skeleton width="100%" height={isDesktop ? "388px" : "240px"} mb="32px" addBorderRadius />

        {/* Meta Info Skeleton */}
        <div style={{ display: "flex", gap: "12px", marginBottom: "16px" }}>
          <Skeleton width="100px" height="24px" addBorderRadius />
          <Skeleton width="200px" height="24px" />
        </div>

        {/* Title Skeleton */}
        <Skeleton width="90%" height="48px" mb="12px" />
        <Skeleton width="70%" height="48px" mb="32px" />

        {/* Table of Contents Skeleton */}
        <Skeleton width="100%" height="200px" mb="32px" addBorderRadius />

        {/* Article Content Skeleton */}
        <Skeleton width="100%" height="24px" mb="16px" />
        <Skeleton width="100%" height="24px" mb="16px" />
        <Skeleton width="95%" height="24px" mb="16px" />
        <Skeleton width="100%" height="24px" mb="16px" />
        <Skeleton width="90%" height="24px" mb="32px" />

        <Skeleton width="100%" height="24px" mb="16px" />
        <Skeleton width="100%" height="24px" mb="16px" />
        <Skeleton width="85%" height="24px" mb="32px" />
      </div>

      {/* Vertical Divider */}
      <div className={styles.verticalDivider} />

      {/* Sidebar Column Skeleton */}
      <div className={styles.sidebar}>
        {/* Featured Blogs Skeleton */}
        <div className={styles.featuredSection}>
          <Skeleton width="200px" height="24px" mb="16px" />
          <div style={{ marginBottom: "24px" }}>
            <div style={{ display: "flex", gap: "16px", marginBottom: "20px" }}>
              <Skeleton
                width={isDesktop ? "123px" : "100px"}
                height={isDesktop ? "95px" : "80px"}
                addBorderRadius
              />
              <div style={{ flex: 1 }}>
                <Skeleton width="80px" height="20px" mb="8px" addBorderRadius />
                <Skeleton width="100%" height="20px" mb="6px" />
                <Skeleton width="90%" height="20px" mb="8px" />
                <Skeleton width="120px" height="16px" />
              </div>
            </div>
            <div style={{ display: "flex", gap: "16px", marginBottom: "20px" }}>
              <Skeleton
                width={isDesktop ? "123px" : "100px"}
                height={isDesktop ? "95px" : "80px"}
                addBorderRadius
              />
              <div style={{ flex: 1 }}>
                <Skeleton width="80px" height="20px" mb="8px" addBorderRadius />
                <Skeleton width="100%" height="20px" mb="6px" />
                <Skeleton width="90%" height="20px" mb="8px" />
                <Skeleton width="120px" height="16px" />
              </div>
            </div>
            <div style={{ display: "flex", gap: "16px" }}>
              <Skeleton
                width={isDesktop ? "123px" : "100px"}
                height={isDesktop ? "95px" : "80px"}
                addBorderRadius
              />
              <div style={{ flex: 1 }}>
                <Skeleton width="80px" height="20px" mb="8px" addBorderRadius />
                <Skeleton width="100%" height="20px" mb="6px" />
                <Skeleton width="90%" height="20px" mb="8px" />
                <Skeleton width="120px" height="16px" />
              </div>
            </div>
          </div>
        </div>

        {/* Sidebar Images Skeleton */}
        <Skeleton width="100%" height={isDesktop ? "390px" : "320px"} mb="24px" addBorderRadius />
        <Skeleton width="100%" height={isDesktop ? "390px" : "320px"} addBorderRadius />
      </div>
    </div>
  </div>
);

export default wrapperHOC(memo(BlogSkeleton), {
  componentName: "BlogSkeleton-Blog",
  showForChina: true,
});
